module.exports = __webpack_public_path__ + "static/media/APEL166dacbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/APEL.svg
// module id = 1298
// module chunks = 0